import React from "react";

const tabs = [
  { id: "details", label: "Details" },
  { id: "setbacks", label: "Setbacks" },
  { id: "obstacles", label: "Obstacles" },
  { id: "panels", label: "Panels" },
];

const SegmentToggle = ({ activeTab, onChange, theme }) => {
  return (
    <div
      className={`segment-toggle ui-card ui-card--surface-2 ${theme ? "dark" : ""}`}
      role="tablist"
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`segment-toggle-button ${isActive ? "is-active" : ""}`}
            onClick={() => onChange(tab.id)}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default SegmentToggle;
